// https://github.com/d3/d3-interpolate/blob/master/src/number.js
import type { Vector3Tuple } from "three";

export function interpolateLinearDirectly(a: number, b: number, t: number) {
  const aa = +a
  const bb = b - a
  return aa + bb * t
}

export function interpolateVec3LinearDirectly(
  vec1: Vector3Tuple,
  vec2: Vector3Tuple,
  t: number
) {
  const x = interpolateLinearDirectly(vec1[0], vec2[0], t)
  const y = interpolateLinearDirectly(vec1[1], vec2[1], t)
  const z = interpolateLinearDirectly(vec1[2], vec2[2], t)
  return [x, y, z] as Vector3Tuple
}

// Catmull-Rom (uniform, wie im Pro-Editor-Original utils/math/interpolate.ts):
// Kurve durch p1 -> p2, p0/p3 sind die Nachbar-Keyframes (an den Enden auf
// p1/p2 geklemmt). Mit nur zwei Punkten kollabiert das zur Geraden — eine
// sichtbare Kurve braucht mindestens drei Keyframes.
function catmullRom1D(p0: number, p1: number, p2: number, p3: number, u: number) {
  const u2 = u * u
  const u3 = u2 * u
  return (
    0.5 *
    (2 * p1 +
      (-p0 + p2) * u +
      (2 * p0 - 5 * p1 + 4 * p2 - p3) * u2 +
      (-p0 + 3 * p1 - 3 * p2 + p3) * u3)
  )
}

export function catmullRomVec3(
  p0: Vector3Tuple,
  p1: Vector3Tuple,
  p2: Vector3Tuple,
  p3: Vector3Tuple,
  u: number
) {
  return [
    catmullRom1D(p0[0], p1[0], p2[0], p3[0], u),
    catmullRom1D(p0[1], p1[1], p2[1], p3[1], u),
    catmullRom1D(p0[2], p1[2], p2[2], p3[2], u),
  ] as Vector3Tuple
}
